"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var textfieldStyles = require("./TextField.scss");
var TextFieldProps_1 = require("./TextFieldProps");
var IconSvg_1 = require("../IconSvg");
var TextField = /** @class */ (function (_super) {
    __extends(TextField, _super);
    function TextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentTextValue: _this.props.data.input ? _this.props.data.input : "",
            disabled: _this.props.options.disabled || false,
            maskedValue: _this.props.data.input ? _this.mask(_this.props.data.input) : "",
            showHint: false,
            showPassword: false,
        };
        _this.onChange = function (event) {
            var events = _this.props.events;
            var value = _this.evaluateValue(event);
            _this.setState({
                currentTextValue: value,
                maskedValue: _this.mask(event.currentTarget.value),
            });
            event.currentTarget.value = value;
            if (events && events.onChange) {
                events.onChange(event);
            }
        };
        _this.onMouseDown = function (event) {
            var _a = _this.props, events = _a.events, options = _a.options;
            if (options.disableCopyPaste) {
                event.preventDefault();
            }
        };
        _this.onKeyPress = function (event) {
            var _a = _this.props, events = _a.events, options = _a.options;
            if (options.type === TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD &&
                (event.charCode <= 47 || event.charCode >= 58) &&
                event.which !== 8 &&
                event.which !== 9
                && (event.which <= 95 || event.which >= 106 && event.which !== 37 && event.which !== 39 && event.which !== 46)) {
                event.preventDefault();
            }
            else if (events && events.onKeyPress) {
                var currentTextValue = _this.state.currentTextValue;
                events.onKeyPress(currentTextValue, event);
            }
        };
        _this.onKeyDown = function (event) {
            var _a = _this.props, events = _a.events, options = _a.options;
            if ((options.type === TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD &&
                (event.which <= 47 || event.which >= 58) &&
                event.which !== 8 &&
                event.which !== 9
                && (event.which <= 95 || event.which >= 106) && event.which !== 37 && event.which !== 39 && event.which !== 46) ||
                (options.disableCopyPaste &&
                    event.ctrlKey &&
                    (event.keyCode === 88 || event.keyCode === 67 || event.keyCode === 86))) {
                event.preventDefault();
            }
            else if (events && events.onKeyDown) {
                var currentTextValue = _this.state.currentTextValue;
                events.onKeyDown(currentTextValue, event);
            }
        };
        _this.onKeyUp = function (event) {
            var events = _this.props.events;
            if (events && events.onKeyUp) {
                var currentTextValue = _this.state.currentTextValue;
                events.onKeyUp(currentTextValue, event);
            }
        };
        _this.onBlur = function () {
            var _a = _this.props, data = _a.data, events = _a.events;
            if (data.hintText) {
                _this.setState({ showHint: false });
            }
            if (events && events.onBlur) {
                var currentTextValue = _this.state.currentTextValue;
                events.onBlur(currentTextValue);
            }
        };
        _this.onFocus = function (event) {
            var _a = _this.props, data = _a.data, events = _a.events;
            if (data.hintText) {
                _this.setState({ showHint: true });
            }
            if (events && events.onFocus) {
                var currentTextValue = _this.state.currentTextValue;
                events.onFocus(currentTextValue, event);
            }
        };
        _this.prevent = function (event) {
            var _a = _this.props, events = _a.events, options = _a.options;
            if (options.disableCopyPaste) {
                event.preventDefault();
            }
        };
        _this.getContainerClass = function () {
            var options = _this.props.options;
            return options.withTooltip
                ? ["rel", options.type === TextFieldProps_1.TextFieldType.PASSWORD].join(" ")
                : "rel";
        };
        _this.handleShowHidePassword = function () {
            _this.setState(function (_a) {
                var showPassword = _a.showPassword;
                return ({ showPassword: !showPassword });
            });
        };
        _this.render = function () {
            var _a = _this.props, data = _a.data, id = _a.id, options = _a.options, spi = _a.spi, testId = _a.testId;
            var _b = _this.state, disabled = _b.disabled, showHint = _b.showHint, showPassword = _b.showPassword;
            var labelClasses = [];
            var inputClasses = ["textfield", _this.props.options.className];
            if (options.error) {
                labelClasses.push("formfield-label error");
                inputClasses.push("error");
            }
            if (disabled) {
                labelClasses.push("disabled");
            }
            var showHidePassword = options && options.showHidePassword;
            var showHideEyePassword = options && options.hasEye;
            var errorInlineText = options.error
                ? options.errorText
                : data.hintText;
            if (errorInlineText && _this.props.options.inLineHtmlParse) {
                errorInlineText = errorInlineText.replace(/ /g, "&nbsp;");
            }
            return (React.createElement("div", { className: "form-row " + _this.getContainerClass(), "data-testid": testId },
                data.labelText && (React.createElement("div", { className: "inline-flex" },
                    React.createElement("label", { className: "formfield-label " +
                            (options.error ? "error" : "") +
                            (disabled ? "disabled" : ""), dangerouslySetInnerHTML: { __html: data.labelText }, htmlFor: id }),
                    React.createElement("span", { className: "hidden-spoken" }, options.error ? options.errorText : data.hintText),
                    options.tooltip !== undefined && options.tooltip)),
                React.createElement("input", { "aria-label": _this.props.options.accessibility ?
                        _this.props.options.accessibility : undefined, "aria-describedby": _this.props.data.ariaDescribedBy ?
                        _this.props.data.ariaDescribedBy :
                        ((_this.props.data.hintText && !_this.props.options.error) ||
                            (_this.props.options.error && _this.props.options.errorText)
                            ? "msg_" + id
                            : undefined), "aria-invalid": options.error === true ? options.error : undefined, autoComplete: options.autocompleteOption, className: inputClasses.join(" "), "data-spi": spi, disabled: disabled, id: id, maxLength: options.maxLength, name: data.name, onBlur: _this.onBlur, onChange: _this.onChange, onFocus: _this.onFocus, onKeyDown: _this.onKeyDown, onKeyPress: _this.onKeyPress, onKeyUp: _this.onKeyUp, onPaste: _this.prevent, placeholder: data.placeHolder, ref: function (el) { return (_this.inputEl = el); }, type: _this.decideInputType(), value: _this.referenceState(), inputMode: options.inputMode ? options.inputMode : undefined, min: (options.type === "number" && options.minValue !== undefined) ? options.minValue : undefined, max: (options.type === "number" && options.maxValue !== undefined) ? options.maxValue : undefined }),
                _this.props.options.error && _this.props.options.errorText && (React.createElement("div", { className: "formfield-msg", dangerouslySetInnerHTML: _this.props.options.inLineHtmlParse === true
                        ? { __html: errorInlineText }
                        : undefined, id: "msg_" + id, role: "alert", tabIndex: showHint ? 0 : -1 }, _this.props.options.inLineHtmlParse === true ? null : errorInlineText)),
                showHidePassword && (React.createElement("button", { "aria-label": showPassword ? "Hide Text" : "Show Text", className: [
                        textfieldStyles.showHidePasswordButton,
                        "absolute",
                        "pad-xxs",
                        "font-regular",
                        "color-ui-black",
                    ].join(" "), onClick: _this.handleShowHidePassword, tabIndex: 0, type: "button" }, !showPassword ? "Show" : "Hide")),
                showHideEyePassword && (React.createElement("button", { "aria-label": showPassword ? "Hide Text" : "Show Text", className: [
                        textfieldStyles.showHideEyePasswordButton,
                        "absolute",
                        "pad-xxs",
                    ].join(" "), onClick: _this.handleShowHidePassword, tabIndex: 0, style: { width: "2em" }, type: "button" },
                    showPassword === true && (React.createElement(IconSvg_1.default, { colorClass: "color-ui-black", size: 24, svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M11.77 8.94l-1.5-1.5a12.28 12.28 0 0114.35 2.14L31 16l-6 6.13-1.41-1.42 4.6-4.71-5-5A10.08 10.08 0 0016 8a10.27 10.27 0 00-4.23.94zm9.64 9.64a6 6 0 00-8-8L15 12.15a3.81 3.81 0 011-.15 4 4 0 014 4 3.81 3.81 0 01-.15 1zm7.24 10.07l-1.42 1.41-5.47-5.47a12.21 12.21 0 01-14.41-2.16L1 16l6.07-6.1-5.13-5.13 1.41-1.42 5.21 5.21L10 10l1.77 1.77 1.41 1.41 5.66 5.66 1.41 1.41L22 22l1.43 1.43zM12 16a4 4 0 004 4 3.81 3.81 0 001-.15L12.15 15a3.81 3.81 0 00-.15 1zm8.26 7.09l-1.68-1.68a6 6 0 01-8-8l-2.1-2.1L3.81 16l5 5a10.17 10.17 0 0011.49 2.07z\"/></svg>" })),
                    showPassword === false && (React.createElement(IconSvg_1.default, { colorClass: "color-ui-black", size: 24, svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M24.62 9.58a12.24 12.24 0 00-17.24 0L1 16l6.36 6.43a12.19 12.19 0 0017.3 0L31 16zM23.23 21a10.19 10.19 0 01-14.46 0l-5-5 5-5a10.21 10.21 0 0114.4 0l5 5zM16 10a6 6 0 106 6 6 6 0 00-6-6zm0 10a4 4 0 114-4 4 4 0 01-4 4z\"/></svg>" })))),
                _this.props.data.hintText && !_this.props.options.error && (React.createElement("div", { className: "formfield-msg", dangerouslySetInnerHTML: _this.props.options.inLineHtmlParse === true
                        ? { __html: data.hintText ? data.hintText : "" }
                        : undefined, id: "msg_" + id, tabIndex: showHint ? 0 : -1 }, _this.props.options.inLineHtmlParse === true ? null : data.hintText))));
        };
        return _this;
    }
    TextField.prototype.UNSAFE_componentWillReceiveProps = function (newProps) {
        var options = this.props.options;
        var _a = this.state, currentTextValue = _a.currentTextValue, disabled = _a.disabled;
        if (newProps.data.input !== currentTextValue) {
            if (options.type === TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD) {
                this.setState({
                    currentTextValue: newProps.data.input,
                    maskedValue: this.mask(newProps.data.input),
                });
            }
            else {
                this.setState({
                    currentTextValue: newProps.data.input,
                });
            }
        }
        if (newProps.options.disabled !== disabled) {
            this.setState({ disabled: newProps.options.disabled });
        }
    };
    TextField.prototype.evaluateValue = function (event) {
        var options = this.props.options;
        var currentTextValue = this.state.currentTextValue;
        var stateValue = currentTextValue ? currentTextValue : "";
        var evaluatedResult = event.currentTarget.value;
        if (options.type === TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD && !this.state.showPassword) {
            var value = event.currentTarget.value;
            var charAt = event.currentTarget.selectionStart;
            // delete key handling
            if (value.length < stateValue.length && charAt) {
                evaluatedResult = stateValue.replace(stateValue.charAt(charAt), '');
            }
            else {
                if (charAt && value.length === charAt) {
                    evaluatedResult = stateValue + value.charAt(value.length - 1);
                }
                else if (charAt) {
                    evaluatedResult = stateValue.slice(0, charAt - 1) + value.charAt(value.length - (value.length - charAt) - 1) +
                        stateValue.slice(charAt - 1);
                }
                else {
                    evaluatedResult = stateValue;
                }
            }
        }
        return evaluatedResult;
    };
    TextField.prototype.decideInputType = function () {
        var options = this.props.options;
        var showPassword = this.state.showPassword;
        var inputType = this.props.options.type;
        switch (options.type) {
            case TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD:
                if (showPassword && options.showHidePassword) {
                    inputType = TextFieldProps_1.TextFieldType.TEL;
                }
                else {
                    inputType = TextFieldProps_1.TextFieldType.PASSWORD;
                }
                break;
            case TextFieldProps_1.TextFieldType.PASSWORD:
                if ((showPassword && options.showHidePassword) ||
                    (showPassword && options.hasEye)) {
                    inputType = TextFieldProps_1.TextFieldType.TEXT;
                }
                break;
        }
        return inputType;
    };
    TextField.prototype.mask = function (value) {
        var maskedValue = "";
        if (value && value !== "") {
            maskedValue = value.replace(/[0-9]/g, TextFieldProps_1.MASK_CHARACTER.DEFAULT);
        }
        return maskedValue;
    };
    TextField.prototype.referenceState = function () {
        var options = this.props.options;
        var _a = this.state, currentTextValue = _a.currentTextValue, maskedValue = _a.maskedValue, showPassword = _a.showPassword;
        return options.type === TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD && showPassword === false
            ? maskedValue
            : currentTextValue;
    };
    TextField.defaultProps = {
        options: {
            autocompleteOption: "on",
            className: "",
            type: TextFieldProps_1.TextFieldType.TEXT,
        },
        spi: false,
    };
    return TextField;
}(React.Component));
exports.default = TextField;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/TextField/TextField.js
// module id = 1658
// module chunks = 8